import axios from "axios";

import { URLS } from "./URLS";

export default async function getAccounts(ls) {
  let param = "";
  if (ls.length === 12) {
    param = "unified_number";
  } else {
    param = "number";
  }
  let data = [];
  await axios(` ${URLS.url}/${URLS.accountsURL}?${param}=${ls}`)
    .then((res) => {
      data = [...res.data];
    })
    .catch(function (error) {
      data.push({ error: "error" });
    });
  return data[0];
}
